/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { customInstance } from '../../../../mutator/instance';
import type { ConnectorType, InternalAccountResponse } from '../../models';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const getBankVirtualAccount = (
  bankUid: string,
  signal?: AbortSignal
) => {
  return customInstance<InternalAccountResponse>({
    url: `/operations/entity-internal-account/banks/${bankUid}`,
    method: 'GET',
    signal,
  });
};

export const getGetBankVirtualAccountQueryKey = (bankUid: string) => {
  return [`/operations/entity-internal-account/banks/${bankUid}`] as const;
};

export const getGetBankVirtualAccountQueryOptions = <
  TData = Awaited<ReturnType<typeof getBankVirtualAccount>>,
  TError = unknown
>(
  bankUid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBankVirtualAccount>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBankVirtualAccountQueryKey(bankUid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBankVirtualAccount>>
  > = ({ signal }) => getBankVirtualAccount(bankUid, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!bankUid,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBankVirtualAccount>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBankVirtualAccountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBankVirtualAccount>>
>;
export type GetBankVirtualAccountQueryError = unknown;

export const useGetBankVirtualAccount = <
  TData = Awaited<ReturnType<typeof getBankVirtualAccount>>,
  TError = unknown
>(
  bankUid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBankVirtualAccount>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBankVirtualAccountQueryOptions(bankUid, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBankVirtualAccount1 = (
  bankUid: string,
  connectorType: ConnectorType,
  signal?: AbortSignal
) => {
  return customInstance<InternalAccountResponse>({
    url: `/operations/entity-internal-account/banks/${bankUid}/${connectorType}`,
    method: 'GET',
    signal,
  });
};

export const getGetBankVirtualAccount1QueryKey = (
  bankUid: string,
  connectorType: ConnectorType
) => {
  return [
    `/operations/entity-internal-account/banks/${bankUid}/${connectorType}`,
  ] as const;
};

export const getGetBankVirtualAccount1QueryOptions = <
  TData = Awaited<ReturnType<typeof getBankVirtualAccount1>>,
  TError = unknown
>(
  bankUid: string,
  connectorType: ConnectorType,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBankVirtualAccount1>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBankVirtualAccount1QueryKey(bankUid, connectorType);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBankVirtualAccount1>>
  > = ({ signal }) => getBankVirtualAccount1(bankUid, connectorType, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(bankUid && connectorType),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBankVirtualAccount1>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBankVirtualAccount1QueryResult = NonNullable<
  Awaited<ReturnType<typeof getBankVirtualAccount1>>
>;
export type GetBankVirtualAccount1QueryError = unknown;

export const useGetBankVirtualAccount1 = <
  TData = Awaited<ReturnType<typeof getBankVirtualAccount1>>,
  TError = unknown
>(
  bankUid: string,
  connectorType: ConnectorType,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBankVirtualAccount1>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBankVirtualAccount1QueryOptions(
    bankUid,
    connectorType,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCustomerVirtualAccount = (
  customerUid: string,
  signal?: AbortSignal
) => {
  return customInstance<InternalAccountResponse>({
    url: `/operations/entity-internal-account/customers/${customerUid}`,
    method: 'GET',
    signal,
  });
};

export const getGetCustomerVirtualAccountQueryKey = (customerUid: string) => {
  return [
    `/operations/entity-internal-account/customers/${customerUid}`,
  ] as const;
};

export const getGetCustomerVirtualAccountQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerVirtualAccount>>,
  TError = unknown
>(
  customerUid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomerVirtualAccount>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCustomerVirtualAccountQueryKey(customerUid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerVirtualAccount>>
  > = ({ signal }) => getCustomerVirtualAccount(customerUid, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!customerUid,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerVirtualAccount>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCustomerVirtualAccountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerVirtualAccount>>
>;
export type GetCustomerVirtualAccountQueryError = unknown;

export const useGetCustomerVirtualAccount = <
  TData = Awaited<ReturnType<typeof getCustomerVirtualAccount>>,
  TError = unknown
>(
  customerUid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomerVirtualAccount>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCustomerVirtualAccountQueryOptions(
    customerUid,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getCustomerVirtualAccount1 = (
  customerUid: string,
  connectorType: ConnectorType,
  signal?: AbortSignal
) => {
  return customInstance<InternalAccountResponse>({
    url: `/operations/entity-internal-account/customers/${customerUid}/${connectorType}`,
    method: 'GET',
    signal,
  });
};

export const getGetCustomerVirtualAccount1QueryKey = (
  customerUid: string,
  connectorType: ConnectorType
) => {
  return [
    `/operations/entity-internal-account/customers/${customerUid}/${connectorType}`,
  ] as const;
};

export const getGetCustomerVirtualAccount1QueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerVirtualAccount1>>,
  TError = unknown
>(
  customerUid: string,
  connectorType: ConnectorType,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomerVirtualAccount1>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCustomerVirtualAccount1QueryKey(customerUid, connectorType);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerVirtualAccount1>>
  > = ({ signal }) =>
    getCustomerVirtualAccount1(customerUid, connectorType, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(customerUid && connectorType),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerVirtualAccount1>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCustomerVirtualAccount1QueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerVirtualAccount1>>
>;
export type GetCustomerVirtualAccount1QueryError = unknown;

export const useGetCustomerVirtualAccount1 = <
  TData = Awaited<ReturnType<typeof getCustomerVirtualAccount1>>,
  TError = unknown
>(
  customerUid: string,
  connectorType: ConnectorType,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomerVirtualAccount1>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCustomerVirtualAccount1QueryOptions(
    customerUid,
    connectorType,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getPlatformVirtualAccount = (
  platformUid: string,
  signal?: AbortSignal
) => {
  return customInstance<InternalAccountResponse>({
    url: `/operations/entity-internal-account/platforms/${platformUid}`,
    method: 'GET',
    signal,
  });
};

export const getGetPlatformVirtualAccountQueryKey = (platformUid: string) => {
  return [
    `/operations/entity-internal-account/platforms/${platformUid}`,
  ] as const;
};

export const getGetPlatformVirtualAccountQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformVirtualAccount>>,
  TError = unknown
>(
  platformUid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPlatformVirtualAccount>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPlatformVirtualAccountQueryKey(platformUid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlatformVirtualAccount>>
  > = ({ signal }) => getPlatformVirtualAccount(platformUid, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!platformUid,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformVirtualAccount>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlatformVirtualAccountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlatformVirtualAccount>>
>;
export type GetPlatformVirtualAccountQueryError = unknown;

export const useGetPlatformVirtualAccount = <
  TData = Awaited<ReturnType<typeof getPlatformVirtualAccount>>,
  TError = unknown
>(
  platformUid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPlatformVirtualAccount>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPlatformVirtualAccountQueryOptions(
    platformUid,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getPlatformVirtualAccount1 = (
  platformUid: string,
  connectorType: ConnectorType,
  signal?: AbortSignal
) => {
  return customInstance<InternalAccountResponse>({
    url: `/operations/entity-internal-account/platforms/${platformUid}/${connectorType}`,
    method: 'GET',
    signal,
  });
};

export const getGetPlatformVirtualAccount1QueryKey = (
  platformUid: string,
  connectorType: ConnectorType
) => {
  return [
    `/operations/entity-internal-account/platforms/${platformUid}/${connectorType}`,
  ] as const;
};

export const getGetPlatformVirtualAccount1QueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformVirtualAccount1>>,
  TError = unknown
>(
  platformUid: string,
  connectorType: ConnectorType,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPlatformVirtualAccount1>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPlatformVirtualAccount1QueryKey(platformUid, connectorType);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlatformVirtualAccount1>>
  > = ({ signal }) =>
    getPlatformVirtualAccount1(platformUid, connectorType, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(platformUid && connectorType),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformVirtualAccount1>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlatformVirtualAccount1QueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlatformVirtualAccount1>>
>;
export type GetPlatformVirtualAccount1QueryError = unknown;

export const useGetPlatformVirtualAccount1 = <
  TData = Awaited<ReturnType<typeof getPlatformVirtualAccount1>>,
  TError = unknown
>(
  platformUid: string,
  connectorType: ConnectorType,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPlatformVirtualAccount1>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPlatformVirtualAccount1QueryOptions(
    platformUid,
    connectorType,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
